import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_WALLET_TOP_UP_OFFERS,
  SAVE_WALLET_TOP_UP_OFFERS,
  DELETE_WALLET_TOP_UP_OFFER,
  FETCH_WALLET_TOP_UP_OFFER_HISTORY,
} from 'actions/walletTopUpOffer';

function* fetchWalletTopUpOffers(action) {
  try {
    const response = yield call(API.getWalletTopUpOffers, action.payload);
    yield put({ type: FETCH_WALLET_TOP_UP_OFFERS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_WALLET_TOP_UP_OFFERS.FAIL, payload: { error: e } });
  }
}

function* fetchWalletTopUpOfferHistory() {
  try {
    const response = yield call(API.getWalletTopUpOfferHistory);
    yield put({ type: FETCH_WALLET_TOP_UP_OFFER_HISTORY.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_WALLET_TOP_UP_OFFER_HISTORY.FAIL, payload: { error: e } });
  }
}

function* saveWalletTopUpOffers(action) {
  try {
    const response = yield call(API.saveWalletTopUpOffers, action.payload);
    yield put({ type: SAVE_WALLET_TOP_UP_OFFERS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: SAVE_WALLET_TOP_UP_OFFERS.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* deleteWalletTopUpOffer(action) {
  try {
    const response = yield call(API.deleteWalletTopUpOffer, action.payload);
    yield put({ type: DELETE_WALLET_TOP_UP_OFFER.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_WALLET_TOP_UP_OFFER.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* walletTopUpOffer() {
  yield takeLatest(FETCH_WALLET_TOP_UP_OFFERS.REQUEST, fetchWalletTopUpOffers);
  yield takeLatest(FETCH_WALLET_TOP_UP_OFFER_HISTORY.REQUEST, fetchWalletTopUpOfferHistory);
  yield takeLatest(SAVE_WALLET_TOP_UP_OFFERS.REQUEST, saveWalletTopUpOffers);
  yield takeLatest(DELETE_WALLET_TOP_UP_OFFER.REQUEST, deleteWalletTopUpOffer);
}

export default walletTopUpOffer;
